import { INoRowsOverlayAngularComp } from '@ag-grid-community/angular';
import { INoRowsOverlayParams } from '@ag-grid-community/core';
import { Component } from '@angular/core';

import { ButtonComponent } from '@shared/components/button/button.component';
import { IconComponent } from '@shared/components/icon/icon.component';

export interface SiteInvoiceablesNoRowsParams extends INoRowsOverlayParams {
  disabled: boolean;
  onAddRow: VoidFunction;
}

@Component({
  imports: [IconComponent, ButtonComponent],
  selector: 'aux-site-invoiceables-no-rows',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  template: `
    <div class="!pointer-events-auto flex h-full flex-col items-center justify-center space-y-4">
      <aux-icon name="SquarePlus" [size]="54" class="!stroke-[1.5] text-[#354052]" />
      <p class="text-2xl font-semibold text-aux-gray-darkest">
        Add your first Site Invoiceable for this site
      </p>

      <p class="text-base">Track site-specific expenses by adding one or more invoiceables</p>

      <aux-button
        (click)="params.onAddRow()"
        icon="Plus"
        label="Site Invoiceable"
        variant="secondary"
        [disabled]="params.disabled"
      />
    </div>
  `,
})
export class SiteInvoiceablesNoRowsComponent implements INoRowsOverlayAngularComp {
  params!: SiteInvoiceablesNoRowsParams;

  agInit(params: SiteInvoiceablesNoRowsParams): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }
}
